module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATZJREFUWEftky1LxlAUgM8Zd8Ffso9zN5bX9ltEg2BRUbAYNBltvuEtFoMGk82gsGS8GERsimEgFhXZdmRhIipy73bxBbk3n/E8ew4HYcYPZ8wHJ+AKuALaBZRSp4i4SkRXNk/XRIARsWHmfd/3t4IgqGyIGAn0QER8att2x/O8PSJ6GyMySOAT8BYA1qWUx0Mlxgr03AtmXkmS5NJUxJZAx2UAOKjrejPLsjtdEZsCPfMZAOallIc6ErYFXpl5u6qq3aIo6j8VYOZzIcRCFEXXOuCPi9IdVkp1O/72upMEgI04jieI+OPMb4yxKzgRQiyFYXiv+yNf54YKPCDiMhEdDQUPXgEiTpumWUvT9HEsvPvepMANIi4S0ZkNsHGBsizn8jx/sQk3KmAbbFzACbgCrsC/LfAO2TlzIalLHskAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/play3.png
// module id = tN3b
// module chunks = 1